module.exports = __webpack_public_path__ + "static/img/default.4d643a2a.svg";